// extracted by mini-css-extract-plugin
module.exports = {"widget":"CalendarWidget_widget__2DtOm","names":"CalendarWidget_names__QHx1v","dayName":"CalendarWidget_dayName__uhKJa","wrapper":"CalendarWidget_wrapper__xSvlE"};